<!--
 * @Description: 个税授权回调
 * @Date: 2024-12-12 11:40:40
-->
<template>
  <div>个税</div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import native from '@/utils/native';

onMounted(() => {
  setTimeout(() => {
    native.method.taxAuthDone();
  }, 500);
});
</script>
